import { Observable } from 'rxjs';

/**
 * Abstract service that consolidates all device state watching functionality.
 * Consuming applications provide a concrete implementation to control which
 * device states the device-ui shell monitors.
 *
 * Replaces the former `DeviceMonitorService` and the watch methods previously
 * found on `DeviceUiShellService` (authentication, uninitialized devices,
 * coverage mode, offline state, language changes, and device name updates).
 */
export abstract class DeviceUiStateWatcherService {
	/**
	 * Watch all relevant device states for the given device.
	 * Implementations should consolidate authentication, uninitialized-device
	 * detection, coverage-mode changes, offline/error states, language changes,
	 * and device-name updates into a single merged observable.
	 *
	 * @param deviceId$ Observable emitting the current device ID.
	 * @returns An `Observable<void>` that stays alive for the lifetime of the subscription.
	 */
	public abstract watch$(deviceId$: Observable<string>): Observable<void>;
}
